import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAdminWorkCalendarDataFromExternalProject } from 'scenes/WorkDemo/services/getAdminWorkCalendarDataFromExternalProject.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { loadRecordAllowancesOfProjectInTimeframe } from 'store/recordAllowances/thunks/loadRecordAllowancesOfProjectInTimeframe.thunk';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const loadAdminWorkCalendarDataFromExternalProject = createAsyncThunk(
  'workCalendar/loadAdminWorkCalendarDataFromExternalProject',
  async (_, { getState, dispatch }) => {
    const { workSearchParams_demo } = getState();

    const selectedProjectId = selectSelectedProjectId(getState());

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    if (selectedProjectId) {
      const fromDate = workSearchParams_demo.fromDate;
      const toDate = workSearchParams_demo.toDate;

      const adminData = await getAdminWorkCalendarDataFromExternalProject(
        selectedProjectId,
        fromDate,
        toDate,
        activeEmployerInfo
      );

      dispatch(loadRecordAllowancesOfProjectInTimeframe({ fromDate, toDate }));

      return adminData;
    } else {
      return;
    }
  }
);
